import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, computed } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { ProjectUserAssociationDeleteDocument, UserType } from '@/gql/graphql';
import { BAlert, BButton, BModal, BSpinner } from 'bootstrap-vue-next';

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectUserAssociationDelete',
  props: {
    show: { type: Boolean },
    user: {},
    projectId: {},
    projectName: {}
  },
  emits: ['close', 'closeAndRefresh'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Component emits ---
const emits = __emit;

// --- Component state ---
const show = computed<boolean>(() => {
  return props.show;
});

// --- Mutation: Rename Data Object ---
const mutationInProgress = ref<boolean>(false);
const mutationError = ref<string | null>(null);
const mutationShowSuccess = ref<boolean>(false);

const {
  mutate: executeMutation,
  onDone: onMutationDone,
  onError: onMutationError,
} = useMutation(ProjectUserAssociationDeleteDocument);

onMutationDone((res) => {
  mutationInProgress.value = false;
  if (res.data && res.data.projectUserAssociationDelete) {
    console.debug(
      'Project-user association deleted:',
      res.data.projectUserAssociationDelete
    );
    mutationShowSuccess.value = true;
    setTimeout(() => {
      mutationShowSuccess.value = false;
      emits('closeAndRefresh');
    }, 1000);
  } else {
    mutationError.value =
      'Project-user association deletion failed: ' + res.data;
    console.error('Project-user association deletion failed:', res.data);
  }
});
onMutationError((err) => {
  console.error('Error deleting project-user association:', err);
  mutationInProgress.value = false;
  mutationError.value = err.message;
});

// --- Handle component actions ---
function onDeletionConfirmed() {
  if (!props.user || !props.user.id) {
    mutationError.value = 'User ID not provided for deletion';
    console.error('User ID not provided for deletion');
    return;
  }
  mutationInProgress.value = true;
  mutationError.value = null;
  executeMutation({ projectId: props.projectId, userId: props.user.id });
}

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
      onHide: handleCloseModal
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "trash",
          class: "me-2"
        }),
        _cache[3] || (_cache[3] = _createTextVNode(" Remove ", -1)),
        _createElementVNode("strong", null, _toDisplayString(props.user.givenName) + " " + _toDisplayString(props.user.familyName), 1),
        _cache[4] || (_cache[4] = _createTextVNode(" from project ", -1)),
        _createElementVNode("strong", null, _toDisplayString(props.projectName), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          variant: "secondary",
          onClick: handleCloseModal
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode(" Cancel ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(BButton), {
          variant: "danger",
          disabled: mutationInProgress.value || mutationShowSuccess.value,
          onClick: onDeletionConfirmed
        }, {
          default: _withCtx(() => [
            (mutationInProgress.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  _cache[9] || (_cache[9] = _createTextVNode(" Removing User from Project ", -1)),
                  _createVNode(_unref(BSpinner), {
                    small: "",
                    label: ""
                  })
                ]))
              : (mutationShowSuccess.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _cache[10] || (_cache[10] = _createTextVNode(" User Removed from Project ", -1)),
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fa', 'check-double'],
                      class: "me-2"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, " Remove User from Project "))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _cache[5] || (_cache[5] = _createTextVNode(" Are you sure you want to remove ", -1)),
            _createElementVNode("strong", null, _toDisplayString(props.user.givenName) + " " + _toDisplayString(props.user.familyName) + " (" + _toDisplayString(props.user.email) + ") ", 1),
            _cache[6] || (_cache[6] = _createTextVNode(" from project ", -1)),
            _createElementVNode("strong", null, _toDisplayString(props.projectName), 1),
            _cache[7] || (_cache[7] = _createTextVNode("? ", -1))
          ]),
          _createVNode(_unref(BAlert), {
            modelValue: mutationError.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mutationError).value = $event)),
            variant: "danger",
            dismissible: "",
            class: "mt-3",
            onDismissed: _cache[1] || (_cache[1] = ($event: any) => (mutationError.value = null))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(mutationError.value), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})